import { FC, useState, useEffect, CSSProperties } from "react";
import clsx from "clsx";

import { createIntervals } from "helpers/createIntervals";
import { Picture } from "pages/startPage/components/picture/picture";

import WalletWebp from "./assests/wallet.webp";
import WalletPng from "./assests/wallet.png";
import CoinsWebp from "./assests/coins.webp";
import CoinsPng from "./assests/coins.png";

import styles from "./style.module.scss";

const initialLoadStatus = 33;
const finalLoadStatus = 99;
const intervalTime = 10;

export interface LoaderProps {
  transparent?: boolean;
  className?: string;
  builtIn?: boolean;
}

export const LoaderWithLogo: FC<LoaderProps> = ({
  transparent = false,
  className,
  builtIn
}) => {
  const [loadStatus, setLoadStatus] = useState(initialLoadStatus);
  const theme = localStorage.getItem("color-scheme") ?? "";
  const { clearIntervals, pushInterval } = createIntervals();

  useEffect(() => {
    pushInterval(() => {
      setLoadStatus((prevStatus) => prevStatus + 1);
    }, intervalTime);
    loadStatus === finalLoadStatus && clearIntervals();
    return () => {
      clearIntervals();
    };
  }, [loadStatus]);

  return (
    <div
      className={clsx(
        styles.main_wrapper,
        !transparent && styles[theme],
        className,
      )}>
      <div className={styles.wrapper}>
        <div className={styles.logo}>
          <span>Faucet</span>
          <span className={styles.logo_blue}>Pay</span>
        </div>
        <div className={styles.external_circle}>
          <div className={styles.inner_circle} />
          <div className={styles.content}>
            <div className={styles.coins_wrapper}>
              <Picture
                sourceSrc={CoinsWebp}
                imgSrc={CoinsPng}
                className={styles.coins}
              />
            </div>
            <Picture
              sourceSrc={WalletWebp}
              imgSrc={WalletPng}
              className={styles.wallet}
            />
            <div className={styles.status_wrapper}>
              <div
                className={styles.status}
                style={
                  { "--load-status-percent": `${loadStatus}%` } as CSSProperties
                }></div>
            </div>
            <span className={styles.percent}>{loadStatus}%</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoaderWithLogo;
